/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  AffiliateTeamAllOf,
  AffiliateTeamAllOfFromJSON,
  AffiliateTeamAllOfFromJSONTyped,
  AffiliateTeamAllOfToJSON,
} from './AffiliateTeamAllOf'
import {
  AffiliateTeamAllOfFarming,
  AffiliateTeamAllOfFarmingFromJSON,
  AffiliateTeamAllOfFarmingFromJSONTyped,
  AffiliateTeamAllOfFarmingToJSON,
} from './AffiliateTeamAllOfFarming'
import {
  AffiliateTeamAllOfStaking,
  AffiliateTeamAllOfStakingFromJSON,
  AffiliateTeamAllOfStakingFromJSONTyped,
  AffiliateTeamAllOfStakingToJSON,
} from './AffiliateTeamAllOfStaking'
import {
  AffiliateTeamAllOfTrading,
  AffiliateTeamAllOfTradingFromJSON,
  AffiliateTeamAllOfTradingFromJSONTyped,
  AffiliateTeamAllOfTradingToJSON,
} from './AffiliateTeamAllOfTrading'
import {
  ReferralsStatistics,
  ReferralsStatisticsFromJSON,
  ReferralsStatisticsFromJSONTyped,
  ReferralsStatisticsToJSON,
} from './ReferralsStatistics'

/**
 *
 * @export
 * @interface AffiliateTeam
 */
export interface AffiliateTeam {
  /**
   *
   * @type {number}
   * @memberof AffiliateTeam
   */
  totalMembers?: number
  /**
   *
   * @type {number}
   * @memberof AffiliateTeam
   */
  totalEarned?: number
  /**
   *
   * @type {number}
   * @memberof AffiliateTeam
   */
  totalPaidFeesInUsd?: number
  /**
   *
   * @type {number}
   * @memberof AffiliateTeam
   */
  todayEarnings?: number
  /**
   *
   * @type {number}
   * @memberof AffiliateTeam
   */
  todayPaidFeesInUsd?: number
  /**
   *
   * @type {number}
   * @memberof AffiliateTeam
   */
  directReferrals?: number
  /**
   *
   * @type {AffiliateTeamAllOfFarming}
   * @memberof AffiliateTeam
   */
  farming?: AffiliateTeamAllOfFarming
  /**
   *
   * @type {AffiliateTeamAllOfTrading}
   * @memberof AffiliateTeam
   */
  trading?: AffiliateTeamAllOfTrading
  /**
   *
   * @type {AffiliateTeamAllOfStaking}
   * @memberof AffiliateTeam
   */
  staking?: AffiliateTeamAllOfStaking
}

export function AffiliateTeamFromJSON(json: any): AffiliateTeam {
  return AffiliateTeamFromJSONTyped(json, false)
}

export function AffiliateTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateTeam {
  if (json === undefined || json === null) {
    return json
  }
  return {
    totalMembers: !exists(json, 'totalMembers') ? undefined : json['totalMembers'],
    totalEarned: !exists(json, 'totalEarned') ? undefined : json['totalEarned'],
    totalPaidFeesInUsd: !exists(json, 'totalPaidFeesInUsd') ? undefined : json['totalPaidFeesInUsd'],
    todayEarnings: !exists(json, 'todayEarnings') ? undefined : json['todayEarnings'],
    todayPaidFeesInUsd: !exists(json, 'todayPaidFeesInUsd') ? undefined : json['todayPaidFeesInUsd'],
    directReferrals: !exists(json, 'directReferrals') ? undefined : json['directReferrals'],
    farming: !exists(json, 'farming') ? undefined : AffiliateTeamAllOfFarmingFromJSON(json['farming']),
    trading: !exists(json, 'trading') ? undefined : AffiliateTeamAllOfTradingFromJSON(json['trading']),
    staking: !exists(json, 'staking') ? undefined : AffiliateTeamAllOfStakingFromJSON(json['staking']),
  }
}

export function AffiliateTeamToJSON(value?: AffiliateTeam | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    totalMembers: value.totalMembers,
    totalEarned: value.totalEarned,
    totalPaidFeesInUsd: value.totalPaidFeesInUsd,
    todayEarnings: value.todayEarnings,
    todayPaidFeesInUsd: value.todayPaidFeesInUsd,
    directReferrals: value.directReferrals,
    farming: AffiliateTeamAllOfFarmingToJSON(value.farming),
    trading: AffiliateTeamAllOfTradingToJSON(value.trading),
    staking: AffiliateTeamAllOfStakingToJSON(value.staking),
  }
}
